import { telPattern } from "./index";
import dayjs from "dayjs";

export const checkTelPattern = (tel: string) => {
  const status: boolean = telPattern.test(tel);
  if (status) return true;
  return false;
};

export const getUrlParam = (name: string) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

export const isWxClient = () => {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
};

export const today = () => {
  let time = dayjs().format("YYYY-MM-DD");
  return time + " 00:00" + " - " + time + " 23:59";
};

export const yestoday = () => {
  let time = dayjs()
    .subtract(1, "day")
    .format("YYYY-MM-DD");
  return time + " 00:00" + " - " + time + " 23:59";
};

export const nowMonth = () => {
  let time1 = dayjs()
    .startOf("month")
    .format("YYYY-MM-DD");
  let time2 = dayjs()
    .endOf("month")
    .format("YYYY-MM-DD");
  return time1 + " 00:00" + " - " + time2 + " 23:59";
};

export const lastMonth = () => {
  let time1 = dayjs()
    .month(dayjs().month() - 1)
    .startOf("month")
    .format("YYYY-MM-DD");
  let time2 = dayjs()
    .month(dayjs().month() - 1)
    .endOf("month")
    .format("YYYY-MM-DD");
  return time1 + " 00:00" + " - " + time2 + " 23:59";
};

//图片压缩动态压缩比计算（100k）
export const ratios = (size: number) => {
  const kb = 1024 * 100;
  let ratio = Math.round(size / kb);
  if (ratio > 50) {
    ratio = 0.2;
  } else {
    ratio = 0.5;
  }
  return ratio;
};

//base64图片压缩
export const compress = (base64String: string, quality: number) => {
  var getMimeType = function(urlData: any) {
    var arr = urlData.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    // return mime.replace("image/", "");
    return mime;
  };
  var newImage = new Image();
  var imgWidth, imgHeight;
  var w = 300;

  var promise = new Promise((resolve) => (newImage.onload = resolve));
  newImage.src = base64String;
  return promise.then(() => {
    imgWidth = newImage.width;
    imgHeight = newImage.height;
    var canvas = document.createElement("canvas");
    var ctx: any = canvas.getContext("2d");
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w;
        canvas.height = (w * imgHeight) / imgWidth;
      } else {
        canvas.height = w;
        canvas.width = (w * imgWidth) / imgHeight;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);
    var base64 = canvas.toDataURL(getMimeType(base64String), quality);
    return base64;
  });
};
